export const ytHavenShouldStart = "yt-haven.should-start";
export const youTubeAlreadyAllowListed = "yt-site.already.allowlisted";
export const youTubeAutoAllowlisted = "yt-auto.allowlisted";
export const youTubeWallDetected = "yt-site.ad-wall-detected";
export const youTubeNavigation = "yt-site.navigation";
export const ytHavenOverlayFlag = "yt-haven-overlay-iframe-enabled";
export const ytHavenModalFlag = "yt-haven-overlay-modal-enabled";
export const ytHavenEmbedFreeFlag = "yt-haven-embed-free";
export const ytHavenEmbedPremiumFlag = "yt-haven-embed-premium";
export const ytHavenDefaultEnabledFlag = "yt-haven-default-enabled";
export const ytHavenToggleStatePrefsKey = "yt_haven_toggle_state";
export const ytHavenToggleState = "yt-haven.toggle-state";
export const ytHavenToggleStateUpdate = "yt-haven.toggle-state-update";
export const ytHavenConflict = "yt-haven.conflict";
export const ytHavenRecordEvent = "yt-haven.record-event";
export const ytHavenInfoBoxShown = "yt_haven_info_box_shown";
export const ytHavenToggleStateEnabled = "yt_haven_toggle_state_enabled";
export const ytHavenToggleStateDisabled = "yt_haven_toggle_state_disabled";
export const ytHavenFeedbackMenuOpen = "yt_haven_feedback_menu_open";
export const matchingElementFoundKey = "matchingElementFound";
export const ytHavenEmbeddedPlayerIssue = "yt-haven.embed-issue";
export const ytHavenNeverShowOverlayClick = "yt-haven.never-show-overlay-clicked";
export const ytHavenMetaTagFound = "yt-haven.meta-tag.found";
export const ytHavenNextVideoNotFound = "yt-haven.next-video-not-found";
export const ytHavenNonEmbeddableFound = "yt-haven.non-embeddable-found";
export const ytHavenNonPlayableFound = "yt-haven.non-playable-found";
export const ytHavenWatchCTAClicked = "yt-haven.watch-cta-clicked";
export const ytHavenOverlayShown = "yt-haven.overlay-shown";
export const ytHavenIframeShown = "yt-haven.iframe-shown";
export const ytHavenModalClosed = "yt-haven.modal-closed";
export const ytHavenLabelWatchingDisable = "yt-haven.label-watching-disable";
export const ytHavenLabelWatchingIgnore = "yt-haven.watching-label-ignore";
